export class TrackingService {
  nyTracker = null;

  readonly TRACKER_TAG = 'NY_TRACKER';

  constructor() {
    this.initTracker();
  }

  initTracker() {
    if (window && window[this.TRACKER_TAG]) {
      this.nyTracker = window[this.TRACKER_TAG]
    } else {
      console.warn("NY_TRACKER not present");
    }
  }

  trackPage(path: string, title: string) {
    if (!this.nyTracker) {
      this.initTracker();
    }
    if (this.nyTracker) {
      this.nyTracker.trackPage(path, title);
    }
  }

  trackClick(event: TrackingEvent) {
    if (!this.nyTracker) {
      this.initTracker();
    }
    if (this.nyTracker) {
      this.nyTracker.trackClick(event)
    }
  }
}

export enum Dimension {
  LIST = 'List',
  DETAIL = 'Detail'
}

export interface TrackingEvent {
  value: number;
  label: string;
  action: string;
  category: string;
  isSale: string;
  likeOrigin: string;
  imageType: string;
}

export const NY_Tracker = new TrackingService();
